/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * field to filter for tag group search by type
 */
export enum TagGroupSearchFilter {
  TAG_GROUP_TYPE_LABEL = 'TAG_GROUP_TYPE_LABEL'
}
